<template>
  <section class="report">
    <div class="report-title-wrap">
      <!-- 국문 -->
      <template v-if="locale === 'ko'">
        <html-view :value="$t('informationCenter.consult.copy')" tag="p" class="report-title-desc" />
        <!--<div v-if="$i18n.locale === 'ko'" class="agree-wrap">
          <div v-if="$t('informationCenter.consult.notice.list')" class="agree-content">
            <div class="agree-term center-agree-term">
              <html-view tag="p" :value="$t('informationCenter.consult.notice.desc')" />
              <ul>
                <template v-for="(item, key) in $t('informationCenter.consult.notice.list')">
                  <html-view :key="key" tag="li" :value="item" />
                </template>
              </ul>
            </div>
          </div>
        </div>-->
      </template>

      <!-- 영문 -->
      <template v-else-if="locale === 'en'">
        <h4 class="report-title">{{ $t('informationCenter.consult.head') }}</h4>
        <html-view :value="$t('informationCenter.consult.copy')" tag="p" class="report-title-desc" />
      </template>
    </div>

    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
      tag="section"
    >
      <form @submit.prevent="submit">
        <div class="support-form">
          <div class="agree-wrap">
            <p class="form-title">
              {{ $t('informationCenter.consult.target') }}
            </p>
            <div class="agree-content">
              <ul class="agree-term">
                <li v-for="(item, key) in $t('informationCenter.consult.targetList')" :key="key">{{ item }}</li>
              </ul>
            </div>
          </div>
          <div class="agree-wrap">
            <p class="form-title">
              {{ $t('informationCenter.protection') }}
            </p>
            <div class="agree-content">
              <ul class="agree-term">
                <li v-for="(item, key) in $t('informationCenter.consult.protection')" :key="key">{{ item }}</li>
              </ul>
            </div>
            <p v-if="locale === 'ko'" class="report-notice">※ 단순 민원, 대상 및 내용이 불명확한 경우, 근거 없는 비방, 단순 의혹제기 등으로 판단되는 경우에는 제보하여도 접수 및 처리가 불가할 수 있습니다.</p>
          </div>

          <input-form
            id="subject"
            ref="subject"
            v-model="subject"
            :title="$t('informationCenter.consult.form.subject')"
            name="subject"
            :placeholder="$t('informationCenter.consult.form.subjectPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="name"
            ref="name"
            v-model="name"
            :title="$t('informationCenter.consult.form.name')"
            name="name"
            :placeholder="$t('informationCenter.consult.form.namePlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            maxlength="50"
            :disabled="anonymous"
          >
            <template v-if="locale === 'ko'" #default>
              <check-box
                id="anonymous"
                ref="anonymous"
                v-model="anonymous"
                :text="$t('informationCenter.consult.form.anonymous')"
                class="check-anonymous"
                name="anonymous"
                @input="onChangeAnonymous"
              />
            </template>
          </input-form>

          <input-form
            id="mail"
            ref="mail"
            v-model="mail"
            :title="$t('informationCenter.consult.form.email')"
            name="mail"
            :placeholder="$t('informationCenter.consult.form.emailPlaceholder')"
            type="email"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="textarea"
            ref="textarea"
            v-model="textarea"
            :title="$t('informationCenter.consult.form.detail')"
            name="textarea"
            :placeholder="$t('informationCenter.consult.form.detailPlaceholder')"
            type="textarea"
            autocomplete="off"
            required="required"
            maxlength="20000"
          />
          <input-form
            id="file"
            v-model="file"
            :title="$t('informationCenter.consult.form.attachFile')"
            :placeholder="$t('informationCenter.consult.form.attachFilePlaceholder')"
            type="file"
            :is-upload="attachFileUrl !== null"
            :loading="fileLoading"
            :error-message="fileError"
            @input="attachUpload"
            @change:delete="onDeleteFile"
          >
            <small>{{ $t('informationCenter.consult.form.attachFileNote') }}</small>
          </input-form>
        </div>

        <div class="support-agree">
          <div class="agree-wrap agree-consult">
            <div class="agree-title">{{ $t('informationCenter.consult.form.privateTitle') }}</div>
            <div class="agree-content">
              <html-view class="agree-term" :value="$t('informationCenter.consult.form.privateValue')" />
              <div class="agree-check">
                <check-box
                  id="private"
                  ref="private"
                  v-model="agreePrivate"
                  :text="$t('informationCenter.consult.form.private')"
                  name="agree-private"
                  required="required"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="support-btn">
          <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">{{ $t('informationCenter.consult.form.submit') }}</button>
        </div>
      </form>
    </validation-observer>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import supportForm from '@/mixins/supportForm'

export default {
  mixins: [supportForm],
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
    })
  },
  watch: {
    agreePrivate (v) {
      this.agreeAll = v
    }
  },
  mounted () {
    this.questionType = 'CONSULT'
  },
  methods: {
    submit () {
      this.saveQuestion({
        title: this.subject,
        name: this.name,
        email: this.mail,
        content: this.textarea,
        type: ['CONSULT']
      }, 'Main', {
        locale: this.$route.params.locale
      })
    },
    onChangeAnonymous (v) {
      this.name = v ? '익명' : ''
    },
    onChangeAgreeAll (v) {
      if (v) {
        this.agreePrivate = true
        this.agreePrecautions = true
      } else {
        this.agreePrivate = false
        this.agreePrecautions = false
      }
    }
  }
}
</script>
